import { Suspense, lazy, type ComponentProps } from 'react';
import { LoadingBlock } from '@/components/ui/State';
import type { MapView } from './MapView';

/**
 * MapLibre тежи около мегабайт — колкото целия останал борд. Бордът е екранът,
 * който стои отворен девет часа; картата се отваря няколко пъти на ден. Затова
 * се зарежда чак когато потрябва.
 */
const MapViewLazy = lazy(() => import('./MapView').then((module) => ({ default: module.MapView })));

export function LazyMap(props: ComponentProps<typeof MapView>) {
  return (
    <Suspense fallback={<LoadingBlock label="Зареждане на картата…" />}>
      <MapViewLazy {...props} />
    </Suspense>
  );
}
